import { SELECT_MODE_ENUM as SELF_PHOTO_SELECT_MODE_ENUM } from '@/router/selfPhoto/config'

export const IMAGES_STORAGE_KEY = 'imagelist'

/* 各个使用到当前组件时的需要显示选择框的场景 */
export const SELECT_MODE_ENUM = {
  ...SELF_PHOTO_SELECT_MODE_ENUM
}
